import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RegistroEntradaVisitanteComponent } from './registro-entrada-visitante.component';

const routes: Routes = [
    { path: '', component: RegistroEntradaVisitanteComponent }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class RegistroEntradaVisitanteRoutingModule { }
